import { url } from "../utils/config";
import axios from "axios";
import Table from "../reusable_components/Table";
import { toast } from "react-toastify";
import { btnGreen, title } from "../utils/style";
import moment from "moment";

function EquipmentCheckout() {
    
    async function checkoutEquipment(id) {
        try {
            const reqUrl = url + '/checkout_equipment/' + id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            toast.success(data.message, { autoClose: 3000 })
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    const options = [
        {
            header: 'REQUESTED BY',
            key: 'reservedBy',
        },
        {
            header: 'EQUIPMENT',
            render: (data) => { return data.special_equipment.name },
            filterKey: 'equipmentNAme'
        },
        {
            header: 'DATE',
            key: 'date',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'CHECK-IN TIME',
            key: 'checkinTime',
        },
        {
            header: 'CHECK-OUT TIME',
            key: 'checkoutTime',
        },
        {
            header: 'ACTION',
            render: (data) => {
                return(
                    <>
                        <button 
                            className={btnGreen}
                            onClick={() => checkoutEquipment(data.id)}
                        >
                            Check-Out
                        </button>
                    </>
                )
            },
        },
    ]

    const excludeFilter = ['ACTION']
 
    return(
        <div className="p-4">
            <div className={`${title} mb-4`}>Equipment Checkout</div>
            
            <Table 
                options={options} 
                url={url + '/equipment_checkout'} 
                pagination 
                noButton
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default EquipmentCheckout